import clsx from 'clsx'
import type { PropsWithChildren, ReactElement } from 'react'
import {
  inputLine,
  inputLineCenter,
  inputLineCompact,
  inputLineJustifyEnd,
  inputLineJustifyStart
} from '~/components/Form/Form.css'

export type InputLineJustify = 'start' | 'end'

export const InputLine = ({
  children,
  justify,
  fluid = false,
  align = 'start'
}: PropsWithChildren<{
  align?: 'center' | 'start'
  justify?: InputLineJustify
  fluid?: boolean
}>): ReactElement => {
  return (
    <div
      className={clsx(
        inputLine,
        align === 'center' && inputLineCenter,
        justify === 'start' && inputLineJustifyStart,
        justify === 'end' && inputLineJustifyEnd,
        fluid && inputLineCompact
      )}
    >
      {children}
    </div>
  )
}
